export const ALLOWEAT_API_ERROR = "alloweat_api_error";
export const ALLOWEAT_API_SERVER_ERROR = "alloweat_api_server_error";
